import React from 'react';
import styled from 'styled-components';
import color from '../../../config/colors.json';


export const Card = styled.div`
    cursor: pointer;
    padding: 60px 10px;
    height: 100%;
    background: transparent;
    box-shadow: 0 1px 3px ${color.lightGrey9};
    border: 1px solid ${color.lightGrey9};
    border-radius: 8px;
    transition: color 0.15s linear;
    transition: border 0.15s linear;
    &.isSelected {
        color: ${color.darkGreyMidias};
        border: 1px solid ${color.darkGreyMidias};
    }
`;

export const Title = styled.div`
	font-size: 20px;
    margin: 10px 0;
`;

export const Label = styled.label`
`;

export const Logo = styled(
    ({ component, ...props }) => React.cloneElement(component, props),
)`
    height: 50px;
    path {
        fill: ${color.lightGrey8};
    }
    &.isSelected {
        path {
            fill: ${color.lightRed};
        }
    }
`;
